import {
	GET_MAP_VIEW_FAIL,
	GET_MAP_VIEW_SUCCESS,
} from '../constants/mapViewConstants';

export const mapViewReducer = (
	state = { mapView: {}, mapViewError: {} },
	action
) => {
	switch (action.type) {
		case GET_MAP_VIEW_SUCCESS:
			return {
				...state,
				mapView: action.payload,
			};
		case GET_MAP_VIEW_FAIL:
			return {
				...state,
				mapViewError: action.payload,
			};

		default:
			return state;
	}
};


